<template>
  <div id="slide-5" class="slide pt-37.5 px-23.5 h-screen relative flex">
    <projectsSlider
        :slides-container-classes="'mb-5 w-full'"
        :slider-classes="''"
        :similar-slides="true"
        :pagination="true"
        :projects="text.projects"
        :all="text.all"
        pagination-container-classes="gap-5"
        class="mb-12.5"
    >
      <template v-slot:slides>
        <div
            class="slider-slide project-slide w-screen flex flex-col"
            v-for="(item, index) in projectsText.projects"
            :class="{'active-slide': index === 0}"
            :key="index"
        >
          <img :src="require('@/assets/images/projects/' + item.id + '/' + item.preview + '.png')" class="client-list-item w-168.5 h-122" alt="">
          <h5 class="mt-7.5 mb-2.5 fz-22 relative" style=" line-height: 1.36;">{{ item.name }}</h5>
          <p class="fz-16 font-medium w-70 text-white" style="line-height: 1.5625;" >{{ item.description }}</p>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </projectsSlider>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import projectsSlider from "@/components/tablet/reuseable/projectsSlider";

export default {
  name: "slide5",
  components:{projectsSlider},
  computed: {
    text() {
      return require("@/assets/text/projects/slide2/" + this.lang + ".json");
    },
    projectsText(){
      return require("@/assets/text/project/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
  methods: {
    ...mapMutations(['setProject', 'setRoute']),
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  transition: all linear 0.3s;
  background: #fff;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}
.project-slide{
  h5,p{
    transition: all linear 0.3s;
  }
  h5{
    left: -3rem;
    color: #6E758D;
    min-height: 1.875rem;
    font-size: 0.9375rem;
  }
  p{
    opacity: 0;
  }
}
.project-slide.active-slide{
  h5{
    left: 0;
    color: #FF2E53;
    font-size: 1.375rem;
  }
  p{
    opacity: 1;
  }
}
</style>
